export enum IconButtonHierarchy {
   Primary = 'PRIMARY',
   Secondary = 'SECONDARY',
   Tertiary = 'TERTIARY'
}

export enum IconButtonSubVariant {
   Primary = 'PRIMARY',
   Destructive = 'DESTRUCTIVE',
   DestructiveOutline = 'DESTRUCTIVE_OUTLINE',
   Gray = 'GRAY',
   GrayOutline = 'GRAY_OUTLINE',
   Success = 'SUCCESS',
   Violet = 'VIOLET'
}
